import { InputSwitch } from "primereact/inputswitch"
import { Control, Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CuentaBancariaFormValues } from "../../UseCuentaBancariasForm"

interface PrincipalSwitchProps {
  control: Control<CuentaBancariaFormValues>
}
export const PrincipalSwitch = ({ control }: PrincipalSwitchProps) => {
  const { t } = useTranslation()
  return (
    <div className='tw-w-full tw-flex tw-flex-row tw-items-center tw-gap-2'>
      <span className='tw-text-sm'>
        {t("contactos.cuentasBancarias.principal")}
      </span>
      <Controller
        name='principal'
        control={control}
        render={({ field }) => (
          <InputSwitch
            checked={field.value}
            onChange={(e) => field.onChange(e.value)}
          />
        )}
      />
    </div>
  )
}
